import jsPDF from 'jspdf';
import autotable from 'jspdf-autotable';

export abstract class BasePdf{

    protected doc = new jsPDF();

    protected borderMargin:BorderMargin={top:0,right:0,bottom:0,left:0}
    protected currCoords:Coordinates={x:0,y:0}

    protected currFontSize = 0;

    protected pageAllowance = 10

    constructor(
        protected borderMarginOption:BorderMarginOption,
        protected orientation:"p" | "portrait" | "l" | "landscape" = 'p',
        protected format = 'government-letter',
    ){        
        this.doc = new jsPDF({
            orientation: orientation,
            unit: 'pt',
            format: format,
            putOnlyUsedFonts:true,
            floatPrecision: 16 // or "smart", default is 16
        });

        this.borderMargin = {
            top: this.convertUnitToPoints(borderMarginOption.unit,borderMarginOption.border.top),
            right: this.convertUnitToPoints(borderMarginOption.unit,borderMarginOption.border.right),
            bottom: this.convertUnitToPoints(borderMarginOption.unit,borderMarginOption.border.bottom),
            left: this.convertUnitToPoints(borderMarginOption.unit,borderMarginOption.border.left),
        }

        this.setFontSize(9)

        this.currCoords = {
            x:this.borderMargin.left,
            y:this.borderMargin.top + this.currFontSize
        }
    }

    protected convertPointsToUnit(points, unit='mm') {
        // Unit table from https://github.com/MrRio/jsPDF/blob/ddbfc0f0250ca908f8061a72fa057116b7613e78/jspdf.js#L791
        var multiplier;
        switch(unit) {
          case 'pt':  multiplier = 1;          break;
          case 'mm':  multiplier = 72 / 25.4;  break;
          case 'cm':  multiplier = 72 / 2.54;  break;
          case 'in':  multiplier = 72;         break;
          case 'px':  multiplier = 96 / 72;    break;
          case 'pc':  multiplier = 12;         break;
          case 'em':  multiplier = 12;         break;
          case 'ex':  multiplier = 6;
          default:
            throw ('Invalid unit: ' + unit);
        }
        return points * multiplier;
    }

    protected convertUnitToPoints(
        unit:"pt" | "px" | "in" | "mm" | "cm" | "ex" | "em" | "pc",
        value
    ) {
        var multiplier;
        switch(unit) {
          case 'pt':  multiplier = 1;          break;
          case 'mm':  multiplier = 72 / 25.4;  break;
          case 'cm':  multiplier = 72 / 2.54;  break;
          case 'in':  multiplier = 72;         break;
          case 'px':  multiplier = 96 / 72;    break;
          case 'pc':  multiplier = 12;         break;
          case 'em':  multiplier = 12;         break;
          case 'ex':  multiplier = 6;
          default:
            throw ('Invalid unit: ' + unit);
        }
        return value * multiplier;
    }

    protected drawBorder(){
        console.log(this.doc.internal.pageSize.getHeight())
        console.log(this.doc.internal.pageSize.getWidth())

        // Horizontal Upper
        this.doc.line(
            this.borderMargin.left,
            this.borderMargin.top,
            this.doc.internal.pageSize.getWidth() - this.borderMargin.right,
            this.borderMargin.top,
            'S'
        )

        // Horizontal Lower
        this.doc.line(
            this.borderMargin.left,
            this.doc.internal.pageSize.getHeight() - this.borderMargin.bottom,
            this.doc.internal.pageSize.getWidth() - this.borderMargin.right,
            this.doc.internal.pageSize.getHeight() - this.borderMargin.bottom,
            'S'
        )

        //Left
        this.doc.line(
            this.borderMargin.left,
            this.borderMargin.top,
            this.borderMargin.left,
            this.doc.internal.pageSize.getHeight() - this.borderMargin.bottom,
            'S'
        )

        //Right
        this.doc.line(
            this.doc.internal.pageSize.getWidth() - this.borderMargin.right,
            this.borderMargin.top,
            this.doc.internal.pageSize.getWidth() - this.borderMargin.right,
            this.doc.internal.pageSize.getHeight() - this.borderMargin.bottom,
            'S'
        )

    }

    protected setFontSize(size) {
        this.doc.setFontSize(size)
        this.currFontSize = size
    }

    protected newPage() {
        this.doc.addPage(this.format,this.orientation)
        this.currCoords = {
            x:this.borderMargin.left,
            y:this.borderMargin.top + this.currFontSize
        }
    }

    protected adjustPage(){
        console.log(this.currCoords.y)
        if ((this.currCoords.y + this.pageAllowance) >= (this.doc.internal.pageSize.getHeight() + this.borderMargin.bottom)){
            this.newPage()
            return true
        }
        return false
    }
}

export interface Coordinates{
    x:number,
    y:number
}

export interface BorderMargin {
    top:number,
    right:number,
    bottom:number,
    left:number
}

export interface BorderMarginOption{
    border:BorderMargin,
    unit:"pt" | "px" | "in" | "mm" | "cm" | "ex" | "em" | "pc"
}